<template>
    <div>
        <portal to="sticky-header" :order="1">
            <b-navbar class="d-none d-md-flex navbar-bold">
                <nav-brand class="py-0 mt-n2"></nav-brand>
                <main-nav class="px-2 main-nav"></main-nav>
                <b-nav class="flex-nowrap align-items-center ml-auto">
                    <support-menu />

                    <user-menu></user-menu>

                  <change-client
                      :defaultText="getClientName()"
                      @change="goToDashboard"
                  />
                </b-nav>
            </b-navbar>
        </portal>

        <b-navbar class="d-flex d-md-none bg-white navbar-bold">
            <nav-brand class="py-0 mt-n2"></nav-brand>
            <b-nav class="flex-nowrap ml-auto">
                <support-menu />

                <user-menu></user-menu>

              <change-client
                  :defaultText="getClientName()"
                  @change="goToDashboard"
              />
            </b-nav>
        </b-navbar>

        <portal to="sticky-header" :order="2">
            <scrollable-widget
                    arrow-bg-color="white"
                    class="tab-nav-wrapper d-block d-md-none pt-1 bg-white">
                <b-navbar class="navbar-wrapper d-flex d-md-none">
                    <main-nav class="navbar-bold"></main-nav>
                </b-navbar>
            </scrollable-widget>
        </portal>

        <portal to="sticky-header" :order="3">
            <component :is="subNav" v-if="subNav" class="sub-nav"></component>
        </portal>
    </div>
</template>

<script lang="js">
import ChangeClient from '@/components/User/ChangeClient';
import UserMenu from '@/components/User/UserMenu';
import MainNav from '@/components/Nav/MainNav';
import NavBrand from '@/components/Nav/NavBrand';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';
import ClientLogo from '@/components/Logo/ClientLogo';
import SupportMenu from '@/components/Nav/SupportMenu.vue';


export default {
  name: 'Nav-bar',
  components: {
    SupportMenu,
    NavBrand,
    ChangeClient,
    MainNav,
    UserMenu,
    ScrollableWidget,
    ClientLogo,
  },
  computed: {
    subNav() {
      if (!this.$route.meta.subNav) {
        return false;
      }

      return this.$route.meta.subNav;
    },
  },
  mounted() {
    this.$store.dispatch('fetchUser');
  },
  methods: {
    getClientName() {
      return this.$store.getters.userClientName;
    },
    goToDashboard() {
      window.location.href = '/actions/dashboard';
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .navbar-bold {
    font-size: $navbar-font-size;
    font-weight: bold;
  }
  .sub-nav {
    background-color: #F7F9FA;
    font-size: $navbar-font-size;
    padding-left: 2.5em
  }
  .nav-item,
  /deep/ .nav-item:not(.b-nav-dropdown) {
      &:first-child a {
          padding-left: 0;
      }

      a.active {
          &:after {
              content: '';
              border-bottom: 2px solid;
              display: block;
              position: relative;
              height: 2px;
              width: 100%;
              background: black;
              bottom: -11px;
              left: 0;
              padding-right: 0.5rem;
              padding-left: 0.5rem;
          }
      }

      &:not(:last-child) {
          margin-right: map-get($spacers, 4);
      }

      white-space: nowrap;
  }

  /deep/ .dropdown-menu {
      max-height: 90vh;
      overflow-y: auto;

      @include media-breakpoint-down(sm) {
          z-index: $zindex-sticky + 5;
          max-height: 80vh;
      }
  }

  .sub-nav /deep/ {
      .navbar {
          .nav-link {
              padding-top: map_get($spacers, 1);
              padding-bottom: map_get($spacers, 1);
          }
      }

      .has-actions {
          max-width: calc(100vw - 475px);
      }

    .badge-pill {
      border-radius: 3px;
      line-height: 1.1;
    }
  }

  @media screen and (max-width: 767px) {
    .sub-nav {
      padding-left: 0;
    }
  }

</style>
